import { getStorage } from "firebase/storage";

import firebaseApp from "../lib/firebaseApp";

export const getFirebaseStorage = () => getStorage(firebaseApp);
